<template>
  <div class="header-page">
    <!-- 收拢/展开菜单 -->
    <div class="switch-collapse-box">
      <el-button :icon="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
                 :title="isCollapse ? '展开' : '收缩'"
                 class="collapse-btn" type="text"
                 @click="switchCollapse">
      </el-button>
    </div>
    
    <div class="right-section">
      <search/>
      <div class="status-indicator">
        <div class="status-dot"></div>
        <span class="status-text">在线</span>
      </div>
      <div class="nickName-box">
        <span>{{nickName}}</span>
      </div>
      <div class="avatar-box">
        <avatar-menu></avatar-menu>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import AvatarMenu from "./components/AvatarMenu/index.vue"
  import Search from "./components/Search.vue"
  export default {
    name: "HeaderPage",
    components: {AvatarMenu,Search},
    computed: {
      ...mapGetters([
        'isCollapse'
      ]),
      nickName() {
        return this.$store.state.nickName;
      }
    },
    methods: {
      switchCollapse() {
        this.$store.commit("switchCollapse")
      }
    }
  }
</script>

<style scoped lang="scss">
  .header-page {
    box-sizing: border-box;
    height: $header-height;
    background: rgba(255, 255, 255, 0.98);
    padding: 0 20px 0 0;
    border-bottom: 1px solid rgba(59, 130, 246, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(10px);
    animation: slideDown 0.4s ease-out;
    position: relative;
    overflow: hidden;
    
    .switch-collapse-box {
      display: flex;
      align-items: center;
      height: 100%;
      padding: 0 16px;
      position: relative;
      z-index: 1;
      
      .collapse-btn {
        vertical-align: middle;
        font-size: 22px;
        color: #2563eb;
        padding: 8px;
        border-radius: 12px;
        transition: all 0.3s ease;
        
        &:hover {
          background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%);
          transform: scale(1.1);
          color: #1d4ed8;
        }
        
        &:active {
          transform: scale(0.95);
        }
      }
    }
    
    .right-section {
      display: flex;
      align-items: center;
      gap: 16px;
      position: relative;
      z-index: 1;
    }
    
    .status-indicator {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 14px;
      background: rgba(16, 185, 129, 0.08);
      border-radius: 20px;
      animation: fadeIn 0.5s ease-out 0.25s both;
      
      .status-dot {
        width: 8px;
        height: 8px;
        background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
        border-radius: 50%;
        animation: statusPulse 2s ease-in-out infinite;
        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);
      }
      
      .status-text {
        font-size: 12px;
        color: #059669;
        font-weight: 600;
      }
    }
    
    .avatar-box {
      display: flex;
      align-items: center;
      animation: fadeIn 0.5s ease-out 0.4s both;
    }
    
    .nickName-box {
      display: flex;
      align-items: center;
      gap: 8px;
      
      i {
        color: #2563eb;
        font-size: 16px;
        animation: iconRotate 3s ease-in-out infinite;
      }
      
      span {
        color: #1e40af;
        font-weight: 600;
        font-size: 14px;
        padding: 6px 16px;
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(59, 130, 246, 0.05) 100%);
        border-radius: 20px;
        animation: fadeIn 0.5s ease-out 0.3s both, nameShimmer 3s ease-in-out infinite;
        position: relative;
        overflow: hidden;
        
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          animation: shimmer 3s ease-in-out infinite;
        }
      }
    }
  }
  
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes buttonGlow {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);
    }
    50% {
      box-shadow: 0 0 0 8px rgba(37, 99, 235, 0.1);
    }
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateX(20px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  
  @keyframes float1 {
    0%, 100% {
      transform: translateY(0) rotate(0deg) scale(1);
    }
    33% {
      transform: translateY(10px) rotate(5deg) scale(1.1);
    }
    66% {
      transform: translateY(-5px) rotate(-3deg) scale(0.95);
    }
  }
  
  @keyframes float2 {
    0%, 100% {
      transform: translateY(0) rotate(0deg) scale(1);
    }
    50% {
      transform: translateY(15px) rotate(-8deg) scale(1.15);
    }
  }
  
  @keyframes float3 {
    0%, 100% {
      transform: translateY(0) rotate(0deg) scale(1);
    }
    25% {
      transform: translateY(-8px) rotate(10deg) scale(1.05);
    }
    75% {
      transform: translateY(12px) rotate(-5deg) scale(0.9);
    }
  }
  
  @keyframes waveMove {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
  
  @keyframes statusPulse {
    0%, 100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);
    }
    50% {
      transform: scale(1.2);
      box-shadow: 0 0 0 12px rgba(16, 185, 129, 0);
    }
  }
  
  @keyframes iconRotate {
    0%, 100% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-10deg);
    }
  }
  
  @keyframes nameShimmer {
    0%, 100% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
  }
  
  @keyframes shimmer {
    0% {
      left: -100%;
    }
    50%, 100% {
      left: 100%;
    }
  }
</style>
